// from '@paperbits/common/utils'; extracted to avoid import cascade
export default function camelCaseToKebabCase(str: string): string {
    return str.replace(/([a-z\d])([A-Z])/g, '$1-$2').toLowerCase().replace(/\s/g, '-');
}
